export default {
    Api: {
        //baseUrl: "http://medita.dev",
        baseUrl: "https://api.medita.bg",
    },

    GTM: {
        id: "GTM-NSHPB8T"
    },

    GA: {
        id: "UA-109155395-1"
    },

    //baseUrl: "http://localhost:3000",
    baseUrl: "https://medita.bg",
    blogUrl: "https://medita.bg/blog"
};





// WEBPACK FOOTER //
// ./src/config.js